import { render, staticRenderFns } from "./TheSignupForm.vue?vue&type=template&id=dc585f6e"
import script from "./TheSignupForm.vue?vue&type=script&lang=js"
export * from "./TheSignupForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports